var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BuilderHeaderPrimary',{staticClass:"page-layout__header page-layout__header--sticky"}),_c('BuilderHeatmapHeader',{staticClass:"page-layout__header-heatmap"}),_c('BuilderRoot',{staticClass:"page-layout"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }